var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "myexam-card-container" }, [
    _c("div", { staticClass: "grace-container" }, [
      _c(
        "div",
        { staticClass: "exam-title grace-exam-title" },
        [
          _c(
            "el-tooltip",
            {
              staticClass: "item",
              attrs: {
                content: _vm.examtitle,
                effect: "light",
                placement: "top-start",
              },
            },
            [
              _c("div", { staticClass: "title-text" }, [
                _vm._v(_vm._s(_vm.examtitle)),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm.itemType == "exam"
        ? _c("div", { staticClass: "grace-content" }, [
            _c("div", { staticClass: "exam-time" }, [
              _c("div", [
                _c("span", { staticClass: "num-title" }, [
                  _vm._v("考试时间："),
                ]),
                _c("span", { staticClass: "time-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.examInfo["exam_manage_goinglistdata.exam_date_time"]
                    ) + " "
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "exam-row" },
              [
                _c(
                  "el-row",
                  { attrs: { span: 12 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("考试时长："),
                      ]),
                      _vm.examInfo["exam_manage_goinglistdata.exam_time"]
                        ? _c("span", { staticClass: "grace-num-value" }, [
                            _vm._v(
                              _vm._s(
                                _vm.examInfo[
                                  "exam_manage_goinglistdata.exam_time"
                                ]
                              ) + "分钟"
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("考试总分："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.examInfo[
                                "exam_manage_goinglistdata.total_score"
                              ]
                            ) +
                            "分"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { span: 12 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("及格分数："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.examInfo[
                                "exam_manage_goinglistdata.pass_score"
                              ]
                            ) +
                            "分"
                        ),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("考试次数："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.examInfo["exam_manage_goinglistdata.exam_num"]
                            ) +
                            "次"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { span: 12 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("已考次数："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.examInfo["exam_manage_goinglistdata.last_num"]
                            ) +
                            "次"
                        ),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("剩余次数："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.examInfo[
                                "exam_manage_goinglistdata.tested_num"
                              ]
                            ) +
                            "次"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.itemType == "training"
        ? _c("div", { staticClass: "grace-content" }, [
            _c("div", { staticClass: "exam-time" }, [
              _c("div", [
                _c("span", { staticClass: "num-title" }, [
                  _vm._v("练习时间："),
                ]),
                _c("span", { staticClass: "time-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.examInfo["exam_training_doingdatalist.training_time"]
                    ) + " "
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "exam-row" },
              [
                _c(
                  "el-row",
                  { attrs: { span: 12 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("总题数："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.examInfo["exam_training_doingdatalist.num"]
                          ) + "个"
                        ),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("单选题："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.examInfo[
                              "exam_training_doingdatalist.radio_num"
                            ]
                          ) + "个"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { span: 12 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("多选题："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.examInfo[
                              "exam_training_doingdatalist.checkbox_num"
                            ]
                          ) + "个"
                        ),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("填空题："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.examInfo[
                              "exam_training_doingdatalist.input_num"
                            ]
                          ) + "个"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { span: 12 } },
                  [
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("判断题："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.examInfo[
                              "exam_training_doingdatalist.judge_num"
                            ]
                          ) + "个"
                        ),
                      ]),
                    ]),
                    _c("el-col", { attrs: { span: 12 } }, [
                      _c("span", { staticClass: "num-title" }, [
                        _vm._v("练习次数："),
                      ]),
                      _c("span", { staticClass: "grace-num-value" }, [
                        _vm._v(
                          _vm._s(
                            _vm.examInfo["exam_training_doingdatalist.last_num"]
                          ) + "次"
                        ),
                      ]),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm.itemType == "exam"
        ? _c("div", { staticClass: "grace-exam-btnnav" }, [
            _c(
              "div",
              {
                staticClass: "grace-exam-button",
                attrs: { type: "plain" },
                on: {
                  click: function ($event) {
                    return _vm.getRules()
                  },
                },
              },
              [_vm._v("考生须知")]
            ),
            _vm.examInfo.isExist == "1"
              ? _c(
                  "div",
                  {
                    staticClass: "grace-exam-button",
                    on: {
                      click: function ($event) {
                        return _vm.checkExam()
                      },
                    },
                  },
                  [_vm._v("查看结果")]
                )
              : _vm._e(),
            _vm.examInfo["viewStatus"] == 2 &&
            _vm.examInfo["exam_manage_goinglistdata.exam_num"] != 0
              ? _c(
                  "div",
                  {
                    staticClass: "grace-exam-button main-button",
                    on: {
                      click: function ($event) {
                        return _vm.continueExam()
                      },
                    },
                  },
                  [_vm._v("继续考试")]
                )
              : _vm._e(),
            (_vm.examInfo["viewStatus"] == 1 ||
              _vm.examInfo["viewStatus"] == 4) &&
            _vm.examInfo["exam_manage_goinglistdata.tested_num"] != 0 &&
            _vm.queryString.type == "0"
              ? _c(
                  "div",
                  {
                    class: [
                      "grace-exam-button",
                      { "main-button": _vm.examInfo["viewStatus"] == 1 },
                    ],
                    on: {
                      click: function ($event) {
                        return _vm.startExam()
                      },
                    },
                  },
                  [_vm._v("开始考试")]
                )
              : _vm._e(),
            _vm.examInfo["viewStatus"] == 3
              ? _c("div", { staticClass: "grace-exam-button" }, [
                  _vm._v("未开始"),
                ])
              : _vm._e(),
            _vm.examInfo["exam_manage_goinglistdata.exam_num"] <= 0
              ? _c(
                  "div",
                  {
                    staticClass: "grace-exam-button",
                    on: {
                      click: function ($event) {
                        return _vm.openExamTips()
                      },
                    },
                  },
                  [_vm._v("提示")]
                )
              : _vm._e(),
          ])
        : _vm._e(),
      _vm.itemType == "training"
        ? _c("div", { staticClass: "grace-exam-btnnav" }, [
            _vm.examInfo["exam_training_doingdatalist.last_num"] > 0 &&
            _vm.examInfo["exam_training_doingdatalist.num"] > 0
              ? _c(
                  "div",
                  {
                    staticClass: "grace-exam-button",
                    attrs: { type: _vm.queryString.type == "0" ? "plain" : "" },
                    on: {
                      click: function ($event) {
                        return _vm.checkTraining()
                      },
                    },
                  },
                  [_vm._v("查看练习")]
                )
              : _vm._e(),
            _vm.examInfo["exam_training_doingdatalist.type"] == 2 &&
            _vm.examInfo["exam_training_doingdatalist.num"] > 0 &&
            _vm.canToTraining === true
              ? _c(
                  "div",
                  {
                    staticClass: "grace-exam-button main-button",
                    on: {
                      click: function ($event) {
                        return _vm.continueTraining()
                      },
                    },
                  },
                  [_vm._v("继续练习")]
                )
              : _vm._e(),
            _vm.examInfo["exam_training_doingdatalist.type"] == 1 &&
            _vm.canToTraining === true
              ? _c(
                  "div",
                  {
                    staticClass: "grace-exam-button main-button",
                    on: {
                      click: function ($event) {
                        return _vm.startTraining()
                      },
                    },
                  },
                  [_vm._v("开始练习")]
                )
              : _vm._e(),
            _vm.showTips === true
              ? _c(
                  "div",
                  {
                    staticClass: "grace-exam-button",
                    on: {
                      click: function ($event) {
                        return _vm.openTrainingTips()
                      },
                    },
                  },
                  [_vm._v("提示")]
                )
              : _vm._e(),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }